__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/67ec342/packs/";